export const ALIGNCENTER = 'alignCenter';